
import Product from '@/graphql/queries/products/Product'

export default {
  meta: {
    query: {
      client: 'eshop',
      type: 'product'
    }
  },
  async asyncData({ $graphql, params, error }) {
    try {
      const { data } = await $graphql.query({
        clientId: 'eshop',
        query: Product,
        variables: { where: { slug: params.id } }
      })

      return { product: data }
    } catch (e) {
      error({ statusCode: 404, message: 'Not found' })
    }
  }
}
